module.exports = "pegasus_template/assets/background-patterns/gray-play.png";